import React, { FC, useMemo } from 'react';
import { Header } from '$uikit';
import { Currency } from '$shared/components';
import { CurrencyEnum } from '$store/models';
import { formatCurrency } from '$utils';
import { useTranslator } from '$hooks';
import { useSelector } from 'react-redux';
import { mainSelector } from '$store/main';
import { balanceSelector } from '$store/balance';

export const TopUpPage: FC = () => {
  const t = useTranslator();
  const { eurBalance, balance, eurTopUpFeeAction } = useSelector(mainSelector);
  const memoEurBalance = useMemo(() => eurBalance, []);
  const { requireTopUpAmount, cryptoPayUrl } = useSelector(balanceSelector);
  const needAmount = requireTopUpAmount
    ? Math.max(
        Math.ceil(
          requireTopUpAmount > memoEurBalance
            ? requireTopUpAmount - memoEurBalance
            : requireTopUpAmount,
        ),
        5,
      )
    : 0;

  return (
    <>
      <Header showBackButton>Top Up</Header>
      <div className="TopUpBalanceSheet__balance">
        <div className="TopUpBalanceSheet__balance__title">{t('balance_available')}</div>
        <div className="TopUpBalanceSheet__balance__amount">
          <Currency amount={memoEurBalance} currency={CurrencyEnum.EUR} />
        </div>
        {requireTopUpAmount > 0 && requireTopUpAmount > memoEurBalance && (
          <div className="TopUpBalanceSheet__balance__amount_tip">
            {t('top_up_balance_need_amount', {
              amount: formatCurrency(needAmount, CurrencyEnum.EUR),
            })}
          </div>
        )}
      </div>
    </>
  );
};
